import {AxiosRequestConfig} from 'axios';

import request from '../../axios';



const getOffers = async (props: IOffersProps) => {
  const {data}: {data: IStoresList} = await request.get(
    'api/v2/store/supplier-advertisement-list',
    {
      params: props,
    } as AxiosRequestConfig,
  );
  return data;
};

export default getOffers;
